<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 19.575C5.45 19.575 4.97917 19.3792 4.5875 18.9875C4.19583 18.5958 4 18.125 4 17.575V15.575C4 15.2917 4.09583 15.0542 4.2875 14.8625C4.47917 14.6708 4.71667 14.575 5 14.575C5.28333 14.575 5.52083 14.6708 5.7125 14.8625C5.90417 15.0542 6 15.2917 6 15.575V17.575H18V15.575C18 15.2917 18.0958 15.0542 18.2875 14.8625C18.4792 14.6708 18.7167 14.575 19 14.575C19.2833 14.575 19.5208 14.6708 19.7125 14.8625C19.9042 15.0542 20 15.2917 20 15.575V17.575C20 18.125 19.8042 18.5958 19.4125 18.9875C19.0208 19.3792 18.55 19.575 18 19.575H6ZM11 7.425L9.125 9.3C8.925 9.5 8.6875 9.59583 8.4125 9.5875C8.1375 9.57917 7.9 9.475 7.7 9.275C7.51667 9.075 7.42083 8.84167 7.4125 8.575C7.40417 8.30833 7.5 8.075 7.7 7.875L11.3 4.275C11.4 4.175 11.5083 4.10417 11.625 4.0625C11.7417 4.02083 11.8667 4 12 4C12.1333 4 12.2583 4.02083 12.375 4.0625C12.4917 4.10417 12.6 4.175 12.7 4.275L16.3 7.875C16.5 8.075 16.5958 8.30833 16.5875 8.575C16.5792 8.84167 16.4833 9.075 16.3 9.275C16.1 9.475 15.8625 9.57917 15.5875 9.5875C15.3125 9.59583 15.075 9.5 14.875 9.3L13 7.425V14.575C13 14.8583 12.9042 15.0958 12.7125 15.2875C12.5208 15.4792 12.2833 15.575 12 15.575C11.7167 15.575 11.4792 15.4792 11.2875 15.2875C11.0958 15.0958 11 14.8583 11 14.575V7.425Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#5C5957",
    },
    size: { type: Number, default: 24 },
  },
};
</script>
